<template>
  <div class="api-lookup-auth-section h-100">
    <Loading :active.sync="isLoading" :is-full-page="false" :color="loaderColor" loader="dots"
      :background-color="loaderBackgroundColor" />
    <!-- Remove this section once the section is implemented. BEGIN -->
    <div class="section-content">
      <div v-for="(param, index) in formFields.parameters" :key="index" class="row">
        <div class="input-container">
          <VasionInput 
            :id="`headerkey-${index}`" 
            v-model="param.HeaderKey" 
            title="Key" 
            inputType="top-white"
            placeholder="Key"
            :required="true"
            @input="emitWrapperIsDirty"
            />
          <VasionInput 
            :id="`headervalue-${index}`"
            v-model="param.HeaderValue" 
            data-paste-target="true"
            title="Value" 
            inputType="top-white"
            placeholder="Value" 
            :required="true"
            @input="emitWrapperIsDirty"
          />
        </div>
        <div title="Encrypt" class="vasion-input-label-top">Encrypt
        <VasionCheckbox 
          id="headerencrypt"
          :checked="param.isEncrypted"
          @change="isEncryptedChanged(param)"
        />
        </div>
        <VasionButton 
          @vasionButtonClicked="deleteRow(index)" 
          icon="VasionDeleteIcon"
        />
      </div>
      <VasionButton 
        class="ml-0"
        classProp="secondary"
        @vasionButtonClicked="addRow">
          New Key Value Pair
      </VasionButton>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import { loaderBackgroundColor, loaderColor } from '@/assets/js/styleConfig'

export default {
  name: 'ApiLookupHeadersFormSection',
  components: {
    Loading
  },
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
  }, 
  data() {
    return {
      formFields: {
        parameters: [],
      },
      formReadyToBeSaved: false,
      isDirty: false,
      isLoading: false,
      loaderBackgroundColor: loaderBackgroundColor,
      loaderColor: loaderColor,
    }
  },
  computed: {
  },
  async created() {
    this.formFields.parameters = this.headers || [];
  },
  methods: {
    addRow() {
      this.formFields.parameters.push({ HeaderKey: '', HeaderValue: '', isEncrypted: false });
      this.emitWrapperIsDirty()
    },
    deleteRow(index) {
      this.formFields.parameters.splice(index, 1);
      this.emitWrapperIsDirty()
    },
    emitWrapperIsDirty() {
      const payload = {
        section: 'headers',
        data: {
          Headers: this.formFields.parameters || [],
        },
      }
      this.$emit('markAsDirty', payload)
    },
    isEncryptedChanged(header) {
      header.isEncrypted = !header.isEncrypted;
      if (!header.isEncrypted) {
        header.HeaderValue = '';
      }
      this.emitWrapperIsDirty();
    },
    setReactiveValue(header, value) {
      const indexStr = header.match(/-(\d+)$/)
      const index = parseInt(indexStr[1])
      this.formFields.parameters[index].HeaderValue = value
      this.emitWrapperIsDirty();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';
@import '@/assets/css/light-theme-system-palette.scss';

::v-deep .ml-0 button {
  margin-left: 0;
}

.section-content {
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.row {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

::v-deep .row .vasion-input {
    margin-left: 10px;
    width: 100%;
}

.input-container {
  display: flex;
  flex: 1;
  gap: 10px;
}

.row .vasion-button {
    background: none;
    border: none;
    cursor: pointer;
    margin-top: 20px;
}

.row .vasion-input-label-top {
    margin-top: -40px;
    margin-left: 10px;
}

.row .vasion-checkbox {
    margin-left: 10px;
    margin-top: 10px;
}

</style>